import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { HiDocumentDownload } from "react-icons/hi";
import "./NavBar.css";

const NavBar = () => {
  // let location = useLocation();
  // if (location.key !== "default") {
  const navigate = useNavigate();

  return (
    <>
      <Navbar expand="lg" className="sticky-top navBar1">
        <Container className="text-center">
          <Navbar.Brand as={NavLink} to="/" className="fw-bold text-white">
            <span className="name">
              Zobaer <span className="name" style={{ color: "#DD1C63" }}>Ahmed</span> Zihad
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                as={NavLink}
                to="/home"
                className="page text-white"

                // activeClassName="active"
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/projects"
                className="page text-white"
                // activeClassName="active"
              >
                Projects
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/blogs"
                className="page text-white"
                // activeClassName="active"
              >
                Blogs
              </Nav.Link>
              {/* <Nav.Link
                as={NavLink}
                to="/about"
                className="page text-white"
                // activeClassName="active"
              >
                About
              </Nav.Link> */}
              <Nav.Link
                as={NavLink}
                to="/contact"
                className="page text-white"
                // activeClassName="active"
              >
                Contact Us
              </Nav.Link>
              <a
                className="resume text-white"
                href="https://drive.google.com/u/0/uc?id=1ypb8q4ZNUqPpJlHsHoyQ_0b7wa2Gc7mt&export=download"
                target="_blank."
              >
                Download Resume
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* <Navbar bg="dark" variant="light" expand='lg' className="sticky-top">
        <Container>
          <Link to="/" className="header__menu">
            Zobaer Ahmed <span className="selected__name"> Zihad</span>
          </Link>
          <Nav className="ms-auto">
            <NavLink className="link" to="/home">
              Home
            </NavLink>
            <NavLink className="link" to="/about">
              About
            </NavLink>
            <NavLink className="link" to="/projects">
              Projects
            </NavLink>
            <NavLink className="link" to="/blogs">
              Blogs
            </NavLink>
            <NavLink className="link" to="/contact">
              Contact
            </NavLink>
          </Nav>
          <a
            className="resumeBtn"
            target="_blank."
            href="https://drive.google.com/u/0/uc?id=1ypb8q4ZNUqPpJlHsHoyQ_0b7wa2Gc7mt&export=download"
          >
            <HiDocumentDownload />Resume
          </a>
        </Container>
      </Navbar> */}
    </>
  );
  // }
};

export default NavBar;
